var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.91516 16.231H25.5818","stroke":"#F4F4F4","strokeWidth":"5.33333","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16.2485 6.89746L25.5819 16.2308L16.2485 25.5641","stroke":"#F4F4F4","strokeWidth":"5.33333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Arrow.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
